import { PlaceholderSection } from '../components/PlaceholderSection'

export function FlowOfFundsPage() {
  return <PlaceholderSection title="Flow of Funds" />
}
